/* Toolbar pin reconciliation (additive, like FormaDock's `seen` list).
   A saved pin list only knows the items that existed when it was saved, so
   an item shipped later would read as "unpinned" forever. `seen` records
   every id the user has been offered: an id never seen joins the pins once
   (every toolbar item is default-pinned); after that the user's choice
   stands. No storage key is bumped — `seen` is a new sibling key. */

/** Ids that shipped after pin lists were first saved. A legacy list (no
 *  `seen` yet) treats every OTHER id as already offered, so items the user
 *  deliberately unpinned earlier are not resurrected. */
export const LEGACY_NEW_IDS: readonly string[] = ['master-updates'];

export interface PinReconcile {
  pins: string[];
  seen: string[];
  changed: boolean;
}

export function reconcilePins(
  pins: string[],
  seen: string[] | null,
  customIds: string[],
  legacyNew: readonly string[] = LEGACY_NEW_IDS
): PinReconcile {
  const known = seen ?? [
    ...new Set([...pins, ...customIds.filter((id) => !legacyNew.includes(id))]),
  ];
  const fresh = customIds.filter((id) => !known.includes(id));
  const nextSeen = [...new Set([...known, ...customIds])];
  const nextPins = fresh.length ? [...pins, ...fresh.filter((id) => !pins.includes(id))] : pins;
  const changed = seen === null || fresh.length > 0;
  return { pins: nextPins, seen: nextSeen, changed };
}
